import { render } from "./tabNavigation.vue?vue&type=template&id=041cbfbb&scoped=true&ts=true"
import script from "./tabNavigation.vue?vue&type=script&lang=ts"
export * from "./tabNavigation.vue?vue&type=script&lang=ts"

import "./tabNavigation.vue?vue&type=style&index=0&id=041cbfbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041cbfbb"]])

export default __exports__